import { render, staticRenderFns } from "./basic-info.vue?vue&type=template&id=67a46a9d&scoped=true"
import script from "./basic-info.vue?vue&type=script&lang=js"
export * from "./basic-info.vue?vue&type=script&lang=js"
import style0 from "./basic-info.vue?vue&type=style&index=0&id=67a46a9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a46a9d",
  null
  
)

export default component.exports